<template>
  <v-container>
    <v-row>
      <v-col
        cols="4"
        md="2"
      >
        <b>Employer Nationality</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        {{ maid.employer_nationality }}
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <b>Type of Worker:</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p
          v-for="(item, i) in maid.type_of_worker"
          :key="i"
        >
          {{ item }}
        </p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <b>Work Schedule:</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p
          v-for="(item, i) in maid.work_day"
          :key="i"
        >
          {{ item }}
        </p>
        <span
          v-show="maid.work_day.includes('Other')"
        >
          {{ maid.work_day_other }}
        </span>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <b>Work Time:</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        {{ maid.work_time }}
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <b>Type of Work Schedule:</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        {{ maid.work_type }}
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <b>Helper Nationality</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p
          v-for="(item, i) in maid.helper_nationality"
          :key="i"
        >
          {{ item }}
        </p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <b>Expected Language from Helper</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        <p
          v-for="(item, i) in maid.expect_language"
          :key="i"
        >
          {{ item }}
        </p>
        <span
          v-if="maid.expect_language.includes('Other')"
        >
          {{ maid.expect_language_other }}
        </span>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <b>Expect helper to cook</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        {{ maid.require_cooking ? 'Yes' : 'No' }}
      </v-col>
      <v-col
        v-if="maid.require_cooking"
        cols="4"
        md="2"
      >
        <b>Kind of Food</b>
      </v-col>
      <v-col
        v-if="maid.require_cooking"
        cols="8"
        md="4"
      >
        {{ maid.food_type }}
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <b>Having Kids:</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        {{ maid.any_kid ? 'Yes' : 'No' }}
      </v-col>
      <v-col
        v-if="maid.any_kid"
        cols="4"
        md="2"
      >
        <b>How many kids</b>
      </v-col>
      <v-col
        v-if="maid.any_kid"
        cols="8"
        md="4"
      >
        {{ maid.kid_amount ? 'Yes' : 'No' }}
      </v-col>
      <v-col
        v-if="maid.any_kid"
        cols="4"
        md="2"
      >
        <b>Kids Ages</b>
      </v-col>
      <v-col
        v-if="maid.any_kid"
        cols="8"
        md="4"
      >
        Month: {{ maid.age_month }}
        <br/>
        Year: {{ maid.age_year }}
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <b>Having Pets:</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        {{ maid.any_pet ? 'Yes' : 'No' }}
      </v-col>
      <v-col
        v-if="maid.any_pet"
        cols="4"
        md="2"
      >
        <b>How many pets</b>
      </v-col>
      <v-col
        v-if="maid.any_pet"
        cols="8"
        md="4"
      >
        {{ maid.amount_pet }}
      </v-col>
      <v-col
        v-if="maid.any_pet"
        cols="4"
        md="2"
      >
        <b>Type of Pets:</b>
      </v-col>
      <v-col
        v-if="maid.any_pet"
        cols="8"
        md="4"
      >
        <p
          v-for="(item, i) in maid.type_of_pet"
          :key="i"
        >
          {{ item }}
        </p>
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <b>How many maids/nannies currently working?</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        {{ maid.amount_current_helper }}
      </v-col>
      <v-col
        cols="4"
        md="2"
      >
        <b>Special Requirement</b>
      </v-col>
      <v-col
        cols="8"
        md="4"
      >
        {{ maid.special_requirement }}
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'MaidDetail',
  props: ['maid']
}
</script>
